import { useDioxus } from '@/lib/wasm'

export function LoadingDocumentPage() {
  const ref = useDioxus('mount_loading_document_page')
  return <div ref={ref} className="contents" />
}
